import { render, staticRenderFns } from "./RELSubsidioMensal.vue?vue&type=template&id=625c370c&scoped=true&"
import script from "./RELSubsidioMensal.vue?vue&type=script&lang=js&"
export * from "./RELSubsidioMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c370c",
  null
  
)

export default component.exports